export const RECEIVABLES = 'receivables';
export const PAYABLES = 'payables';
